// Transparent 1x1 pixel image
export const EMPTY_IMAGE_PLACEHOLDER =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=';

export const BASE_64_SVG_IMAGE_PREFIX = 'data:image/svg+xml;base64,';

export const CROP_MARKER_COLOR = 0x012345;
